import {connect} from "react-redux";
import FreeGameAd from "./FreeGameAd.jsx";

const mapStateToProps = (state) => {
    return {
        show: state.games.current && state.games.current.isFreeWithAds,
    };
};


const FreeGameAdContainer = connect(
    mapStateToProps,
)(FreeGameAd);

export default FreeGameAdContainer